import { gql } from '@apollo/client';

export const EXPORT_FUNDER_SCHOOL_ENROLMENT = gql`
  query ExportFunderSchoolEnrolment($input: ExportArgs!) {
    exportFunderSchoolEnrolment(input: $input) {
      id
      name
      class
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subject {
        id
        name
        subjectGradeReference
      }
      schoolEnrolmentData {
        id
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        grade {
          id
          value
        }
        institution {
          id
          emisNumber
          name
        }
        numberEnrolled
        numberWithoutID
        promotionStatus {
          id
          name
        }
        term
        year
      }
    }
  }
`;
